module.exports = __webpack_public_path__ + "img/mo.ff89710e.png";